module.exports = __webpack_public_path__ + "static/cloudstands-4cf51d151e15b18cc703ac7a54e97f50.png";